export enum AUDIO_PLAYER_ERROR {
  RENDER = "AUDIO_RENDERER_ERROR: audio render error",
  DATA_SOURCE = "PIPELINE_ERROR_READ: FFmpegDemuxer: data source error",
}
